<template lang="pug">
div.fullmenu(:style="menuPaddingTop ? 'padding-top: ' + menuPaddingTop + 'px' : '' ")
    div.row
        div.col-sm-2.order-sm-2.col-lg.order-lg-1
            h3.d-none.d-sm-block {{ $t('$menu.language.name') }}
            div.links
                div
                    a.menu(href="#" @click.prevent="changeLanguage") {{ $t('$menu.language.other') }}

        div.col-6.col-sm-2.col-lg(:class="[link.display, link.order]" v-for="(link, key) in menu")
            h3
                template(v-if="$store.state.links[key].url")
                    router-link.menu.grey(:to="getLocalizedUrl($store.state.links[key].url)" @click.native="close") {{ $t($store.state.links[key].name) }}
                template(v-else) {{ $t($store.state.links[key].name) }}
            div.links
                div(v-for="sublink in $store.state.links[key].sublinks")
                    a.menu(v-if="$store.state.links[key].blank" :href="sublink.url" target="_blank") {{ sublink.name }}
                    router-link.menu(v-else-if="sublink.id" :to="getLocalizedUrl(sublink.url)" @click.native="close") {{ sublink.name[$i18n.locale] }}
                    router-link.menu(v-else :to="getLocalizedUrl(sublink.url)" @click.native="close") {{ $t(sublink.name) }}
    div.language-switch
        a.menu(href="#" @click.prevent="changeLanguage") {{ $t('$menu.language.other') }}
</template>

<script>
export default {
    name: 'fullmenu',
    data() {
        return {
            menu: {
                main: {
                    display: 'd-block d-sm-none',
                },
                projects: {
                    order: 'order-sm-1 order-lg-2'
                },
                blog: {
                    order: 'order-sm-1 order-lg-2'
                },
                studio: {
                    order: 'order-sm-1 order-lg-2'
                },
                contacts: {
                    order: 'order-sm-3 order-lg-2'
                },
                follow: {
                    order: 'order-sm-3 order-lg-2',
                    display: 'd-none d-sm-block'
                }
            },
            menuPaddingTop: 0
        }
    },
    created() {
        this.$http.get("categories/project").then(response => {
            this.$store.commit("setCategories", {
                type: "projects",
                categories: response.data
            });
        })
        this.$http.get("categories/post").then(response => {
            this.$store.commit("setCategories", {
                type: "blog",
                categories: response.data
            });
        })
    },
    methods: {
        changeLanguage() {
            const currentPath = this.$route.path
            const currentHash = this.$route.hash || ''
            
            if (this.isEnglish) {
                // Переключаемся на русский - убираем /en из URL
                const newPath = currentPath.replace(/^\/en/, '') || '/'
                this.$router.push(newPath + currentHash)
            } else {
                // Переключаемся на английский - добавляем /en в URL
                const newPath = '/en' + (currentPath === '/' ? '' : currentPath)
                this.$router.push(newPath + currentHash)
            }
            this.close()
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss">
@import '@styles/mixins.scss';
.fullmenu {
    .language-switch {
        display: none;
        text-align: center;
        margin-top: 20px;
    }
    h3 {
        margin-bottom: 40px;
        color: $color-black40;
    }
    .links>div {
        margin-bottom: 5px;
    }
    &>.row>div {
        margin-bottom: 60px;
    }
    @media (max-width: grid-breakpoint(lg)) {
        padding-left: 40px;
        padding-right: 40px;
    }
    @media (max-width: grid-breakpoint(sm)) {
        .links {
            display: none;
        }
        h3 {
            margin-bottom: 0;
            text-align: center;
            .menu {
                font-size: 44px;
                font-weight: 600;
                opacity: 1;
                line-height: 30px;
            }
        }
        &>.row>div {
            margin-bottom: 20px;
        }
        .language-switch {
            display: block;
        }
    }
}
</style>
